import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: theme => ({
    flex: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    marginLeft: -16,
    marginRight: -16,
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 40,
  }),
  title: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.h4
  },
  subtitle: theme => ({
    color: theme.colors.textColor,
    marginVertical: 15,
    fontSize: Fonts.size.regular,
  }),
  row: {
    flexDirection: 'row',
    alignItems: 'baseline',
    paddingVertical: 5,
    marginVertical: 5
  },
  borderBottom: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderColorThree,
    marginBottom: 15,
  }),
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'baseline',
    paddingBottom: 20,
    justifyContent: 'space-between',
  },
  valueDesc: {
    fontSize: Fonts.size.regular,
  },
  valueText: {
    fontSize: Fonts.size.regular,
    ...Fonts.type.bold,
  },
  breakdownTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 10
  },
  breakdownContainer: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColorThree,
    marginLeft: -16,
    marginRight: -16,
    paddingHorizontal: 16,
    marginBottom: 20,
    paddingVertical: 20
  }),
  termsTextContainer: {
    flexDirection: 'row',
    marginVertical: 5,
  },
  termsContainer: {
    paddingVertical: 10,
    marginBottom: 20,
    alignItems: 'center'
  },
  text: {
    fontSize: Fonts.size.regularSmall,
  },
  underline: {
    fontSize: Fonts.size.regularSmall,
    textDecorationLine: "underline",
  },
  titleStyle: {
    marginLeft: -16
  },
  buttonStyle: {
    marginRight: -16
  }
})

export default styles
